import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { Img } from '../Img/Img.js';
import { LinkButton } from '../LinkButton/LinkButton.js';
export const TableInnerButton = JSX(({ className = '', isOpen, onClick }) => (_jsx(LinkButton, { className: className, appendRight: _jsx(Img, { image: { icon: isOpen ? 'ArrowUpIcon' : 'ArrowDownIcon' }, width: "24", height: "24" }), text: isOpen ? 'Скрыть' : 'Показать', version: "gray", onClick: onClick })));
//# sourceMappingURL=InnerTableButton.js.map